import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

export function button1_click(event) {
	$w('#text32').show();
	$w('#button1').hide();
	$w('#button2').show();
	//Add your code for this event here: 
}



export function button4_click(event) {
	if ($w('#firstName').value === 'רבקה') {
			wixLocation.to('https://www.questair.co.il/passoverci');
			}
	else if ($w('#firstName').value === 'Rebecca') {
			wixLocation.to('https://www.questair.co.il/passoverci');
	}
	else if ($w('#firstName').value === 'rebecca') {
			wixLocation.to('https://www.questair.co.il/passoverci');
	}
	else if ($w('#firstName').value === 'REBECCA') {
			wixLocation.to('https://www.questair.co.il/passoverci');
	}
	else if ($w('#firstName').value === 'Despacito') {
			wixWindow.openLightbox("almost");
			}
	else if ($w('#firstName').value === 'DESPACITO') {
			wixWindow.openLightbox("almost");
			}
	else {
		wixWindow.openLightbox("No_Hanukka2018");
	}		
	//Add your code for this event here: 
}

export function button2_click(event) {
	$w('#text33').show();
	$w('#text32').hide();
	$w('#button2').hide();
	$w('#button3').show();
	//Add your code for this event here: 
}

export function button3_click(event) {
	$w('#button2').hide();
	$w('#button3').hide();
	$w('#text33').hide();
	$w('#text34').show();
	//Add your code for this event here: 
}